export default __webpack_public_path__ + "static/media/tensio-plegador.8291295c.png";